<template>
  <div>
    <!-- 左滑提示 -->
    <van-notice-bar mode="closeable" style="padding-top:0">单元格左滑可以操作对应岗位哦！</van-notice-bar>
    <!-- 添加按钮 -->
    <add-btn v-hasPermi="['system:post:add']" @add="handleAdd"></add-btn>
    <!-- 岗位列表区 start -->
    <van-swipe-cell v-for="item in postList" :key="item.postId">
      <van-cell :title="item.postName" />
      <template #right>
        <van-button square type="primary" text="修改" @click="handleUpdate(item)" v-hasPermi="['system:post:edit']" />
        <van-button square type="danger" text="删除" @click="handleDelete(item)" v-hasPermi="['system:post:remove']" />
      </template>
    </van-swipe-cell>
    <!-- 岗位列表区 end -->
    <!-- 修改岗位信息弹框区 start -->
    <van-dialog v-model="open" :title="dialog_title" :beforeClose="editPostBeforeClose" close-on-click-overlay>
      <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap">
        <van-cell-group>
          <van-field v-model="form.postName" label="岗位名称" :rules="[{ required: true }]" required placeholder="请填写岗位名称"/>
          <van-field v-model="form.postCode" label="岗位编码" :rules="[{ required: true }]" required placeholder="请填写岗位编码"/>
          <van-field label="岗位顺序" required :rules="[{ required: true}]" placeholder="请选择岗位顺序">
            <template #input>
              <van-stepper v-model="form.postSort" />
            </template>
          </van-field>
          <van-field label="状态" required>
            <template #input>
              <van-radio-group v-model="form.status" direction="horizontal">
                <van-radio :name="item.dictValue" v-for="item in statusOptions" :key="item.dictValue" icon-size="14px">{{ item.dictLabel }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field type="textarea" v-model="form.remark" label="备注" />
        </van-cell-group>
      </van-form>
    </van-dialog>
    <!-- 修改岗位信息弹框区 end -->
  </div>
</template>
<script>
import { Collapse, CollapseItem, Icon, SwipeCell, Button, Cell, NoticeBar, Dialog, CellGroup, Form, Field, RadioGroup, Radio, Stepper, Toast } from 'vant'
import { listPost, getPost, delPost, addPost, updatePost } from "@/api/system/post";
import AddBtn from "@/components/common/AddBtn";
export default {
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Stepper.name]: Stepper,
    [Button.name]: Button,
    [SwipeCell.name]: SwipeCell,
    [NoticeBar.name]: NoticeBar,
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    AddBtn
  },
  data() {
    return {
      open: false,
      form: {},
      // 查询参数
      queryParams: {
        deptName: undefined,
        status: undefined
      },
      radio: '1',
      statusOptions: this.$store.state.dictOptions.status || [],
      postList: [],
      dialog_title: ''
    }
  },
  mounted() {
    this.getList()
    //状态字段
    // this.getDicts("sys_normal_disable").then(response => {
    //   this.statusOptions = response.data;
    // });
  },
  methods: {
    /** 查询部门列表 */
    getList() {
      listPost(this.queryParams).then(response => {
        console.log(this.response);
        this.postList = response.rows;
      });
    },
    // 表单重置
    reset() {
      this.form = {
        postId: null,
        postCode: null,
        postName: null,
        postSort: 0,
        status: "0",
        remark: null
      };
    },
    // 关闭修改合同弹框
    async editPostBeforeClose(action, done) {
      if (action === 'confirm') {
        try {
          await this.$refs["form"].validate();
          let api = this.form.postId != undefined ? updatePost : addPost,
            msg = this.form.postId != undefined ? '修改成功' : '新增成功';
          api(this.form).then(response => {
            Toast.success(msg);
            this.open = false;
            this.getList();
          });
          done();
        } catch (err) {
          return done(false);
        }
      } else {
        return done();
      }
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.postId != undefined) {
            updatePost(this.form).then(response => {
              this.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addPost(this.form).then(response => {
              this.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const postId = row.postId
      getPost(postId).then(response => {
        this.form = response.data;
        this.open = true;
        this.dialog_title = "修改岗位信息";
      });
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.dialog_title = "添加岗位";
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const postIds = row.postId;
      Dialog.confirm({
        title: "警告",
        message: '是否确认删除岗位编号为"' + postIds + '"的数据项?',
      })
        .then(function () {
          return delPost(postIds);
        })
        .then(() => {
          Toast.success("删除成功");
          this.getList();
        })
        .catch(() => { });
    },

  },
}
</script>
<style lang="less">
.van-swipe-cell__left,
.van-swipe-cell__right {
  top: -20px;
}
</style>